'use strict';
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require('../internals/indexed-object');
var requireObjectCoercible = require('../internals/require-object-coercible');

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/to-indexed-object.js
// module id = 31
// module chunks = 0